(() => {
  const setup = (form) => {
    if (!form || form.dataset.vtgReady === 'true') return;
    form.dataset.vtgReady = 'true';

    const radios = [...form.querySelectorAll('input[name="vtg_bundle_quantity"]')];
    const slots = [...form.querySelectorAll('[data-vtg-option-slot]')];

    const sync = () => {
      const quantity = Number(radios.find((radio) => radio.checked)?.value || 1);
      slots.forEach((slot, index) => { slot.hidden = index >= quantity; });
      radios.forEach((radio) => radio.closest('.vtg-bundle__choice')?.classList.toggle('is-selected', radio.checked));
    };

    radios.forEach((radio) => radio.addEventListener('change', sync));
    sync();

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const selectedBundle = radios.find((radio) => radio.checked);
      const quantity = Number(selectedBundle?.value || 1);
      const code = selectedBundle?.dataset.code || '';
      const selects = [...form.querySelectorAll('[data-vtg-variant-select]')].slice(0, quantity);
      const defaultVariant = form.querySelector('[data-vtg-default-variant]')?.value;
      const selectedIds = selects.length
        ? selects.map((select) => select.value)
        : defaultVariant ? Array.from({ length: quantity }, () => defaultVariant) : [];

      const counts = new Map();
      selectedIds.forEach((id) => counts.set(id, (counts.get(id) || 0) + 1));
      const items = [...counts].map(([id, itemQuantity]) => ({ id: Number(id), quantity: itemQuantity }));
      if (!items.length) return;

      const button = form.querySelector('.vtg-bundle__add');
      const note = form.querySelector('[data-vtg-note]');
      const originalText = button?.textContent || 'ADD BUNDLE TO CART';
      if (button) { button.disabled = true; button.textContent = 'ADDING…'; }
      if (note) note.textContent = 'Adding your bundle…';

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'Could not add this bundle');

        if (button) button.textContent = 'ADDED ✓';
        const cartPath = window.routes?.cart_url || `${root}cart`;
        window.location.href = code
          ? `${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(cartPath)}`
          : cartPath;
      } catch (error) {
        if (button) { button.disabled = false; button.textContent = originalText.trim(); }
        if (note) note.textContent = error.message || 'Could not add this bundle. Please try again.';
      }
    });
  };

  const setupAll = (root = document) => root.querySelectorAll?.('[data-vtg-bundle-form]').forEach(setup);
  document.addEventListener('DOMContentLoaded', () => setupAll());
  document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
  setupAll();
})();
